import { Reveal, Splash } from "./decor";
import { Quote, Star } from "lucide-react";

const accents = ["#0066FF", "#00C853", "#FF6B00"];

export const Testimonials = ({ t }) => {
  return (
    <section id="testimonials" className="relative overflow-hidden bg-white py-24 lg:py-32">
      <Splash className="left-[-120px] bottom-10 h-[360px] w-[360px]" color="#FFD600" />
      <Splash className="right-[-120px] top-16 h-[340px] w-[340px]" color="#00C853" delay={0.2} />

      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <Reveal>
          <p className="mb-4 text-sm font-bold uppercase tracking-[0.35em] text-[#00C853]">
            {t.testimonials.eyebrow}
          </p>
          <h2 className="max-w-3xl font-display text-4xl font-black leading-tight tracking-tight text-black sm:text-5xl">
            {t.testimonials.title}
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-3">
          {t.testimonials.items.map((item, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <figure
                className="flex h-full flex-col rounded-3xl border border-black/10 bg-[#FAFAFA] p-8 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_24px_60px_-24px_rgba(0,0,0,0.2)]"
                data-testid={`testimonial-${i}`}
              >
                <Quote className="h-8 w-8" style={{ color: accents[i % 3] }} fill="currentColor" />
                <blockquote className="mt-5 flex-1 text-base leading-relaxed text-black/75">
                  {item.quote}
                </blockquote>
                <div className="mt-6 flex items-center gap-1 text-[#FFD600]">
                  {[...Array(5)].map((_, s) => (
                    <Star key={s} className="h-4 w-4" fill="currentColor" strokeWidth={0} />
                  ))}
                </div>
                <figcaption className="mt-4 border-t border-black/10 pt-4">
                  <p className="font-display text-lg font-black text-black">{item.name}</p>
                  <p className="text-sm text-black/50">{item.role}</p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <p className="mt-8 text-xs italic text-black/40" data-testid="testimonials-note">
            {t.testimonials.note}
          </p>
        </Reveal>
      </div>
    </section>
  );
};
